export default __webpack_public_path__ + "static/media/en_U-SOLVE.c9f29da0.png";